import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { getToastSettings } from "../common/ToastManager";
import { notifyCustomer } from "../../service/notificationService";
import {
  generateNotificationMessageBody,
  processContatcsForNotification,
} from "../../utils/notificationUtils";
import { UserContext } from "../../App";
import { useRef } from "react";
import { useSelectedOrgId } from "../../hooks/useSelectedOrgId";

const Notify = (props) => {
  const [selectedOrgId] = useSelectedOrgId();
  const [accountSummary, setAccountSummary] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState({});
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [loading, setLoading] = useState(true);
  const toastSuccess = (toastMessage) =>
    toast.success(toastMessage, getToastSettings());
  const toastError = (toastMessage) =>
    toast.error(toastMessage, getToastSettings());

  const user = useContext(UserContext);

  const selectRef = useRef();

  useEffect(() => {
    props.setTab("notify");
    setAccountSummary(props.accountSummary);
  }, [props]);

  useEffect(() => {
    accountSummary.forEach((account) => {
      let option = {
        value: account.accountId,
        label: account.name,
      };
      setAccountOptions((prev) => {
        return [...prev, option];
      });
    });
  }, [accountSummary]);

  const handleSendNotificationClick = async () => {
    setLoading(true);
    let contactsData;
    const selectedAccountData = accountSummary.find(
      (account) => account.accountId === selectedAccount.value,
    );
    if (selectedAccountData) {
      contactsData = processContatcsForNotification(
        selectedAccountData.contacts,
      );
    }
    const lead = user["firstName"]
      ? user["firstName"] + " " + user["lastName"]
      : "";
    let result = await generateNotificationMessageBody(
      contactsData,
      additionalNotes,
      selectedAccount.label,
      lead,
    );
    if (result === null) {
      toastError("Account is not configured.");
    } else {
      try {
        let response = await notifyCustomer(result, selectedOrgId);
        if (response.status === 200) {
          setAdditionalNotes("");
          toastSuccess("Notification Sent Successfully!");
        } else {
          if (("res", response.status === 400)) {
            toastError("Notification Sending Failed!");
          } else {
            toastError("Stored locally. waiting for network to sync.");
          }
        }
      } catch (error) {
        toastError("Stored locally. waiting for network to sync.");
      }
    }
    setLoading(false);
  };

  const { t } = useTranslation();
  return (
    <Col className="form-container">
      <Row className="head-label">
        <Col xs={8} style={{ padding: "unset" }}>
          {t("notifyDesc.label")}
        </Col>
      </Row>
      <Row className="form-align-center">
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextAccount">
          <Row>
            <Form.Label column sm="6">
              {t("account.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Select
                options={accountOptions}
                onChange={(e) => {
                  setSelectedAccount(e);
                  setLoading(false);
                }}
                ref={selectRef}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>
      <Row className="form-align-center">
        <Form.Group
          as={Col}
          className="mb-3"
          controlId="formPlaintextVehicleNumber"
        >
          <Row>
            <Form.Label column sm="4">
              {t("additionalNotes.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Form.Control
                as="textarea"
                rows={3}
                value={additionalNotes}
                onChange={(e) => {
                  setAdditionalNotes(e.target.value);
                }}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>

      <Row className="form-align-center" style={{ padding: "1px 10px" }}>
        <Button
          disabled={loading}
          className="login-btn"
          onClick={() => {
            handleSendNotificationClick();
          }}
        >
          <label className="login-btn-label">
            {t("sendNotification.label")}
          </label>
        </Button>
      </Row>
      <ToastContainer />
    </Col>
  );
};

export default Notify;
